import type { ReactElement } from 'react';

import { useAuth } from '@/hooks/useAuth';

export function DashboardPage(): ReactElement {
    const { admin } = useAuth();

    return (
        <div data-testid="dashboard-page">
            <h1 className="mb-2 text-2xl font-semibold text-gray-900">Dashboard</h1>
            <p className="text-gray-600">
                Здравствуйте, {admin?.displayName ?? admin?.email ?? 'администратор'}.
            </p>
        </div>
    );
}
